import React, { useState } from 'react';
import ClientDetails from "lib/ClientDetails"
import DashBoard from 'components/DashBoard';
import VKyc from 'lib/VKyc';
import { dashboardConfig } from 'assets/dashboardConfig'

const ClientDetailDashBoard = (props) => {
  const [activeTab, setActiveTab] = useState(1);

  let sections = {}, formSkeleton = {}, tab = {}

    if (dashboardConfig && Object.keys(dashboardConfig)?.length) {
        let formStructure = []
        dashboardConfig?.wf_journey?.map((item, index) => {
            formStructure = { ...item?.form_structure }
        })

        formSkeleton = formStructure?.sections
    }
   
  return (
    <DashBoard className="">
        {
          activeTab == 1 && 
           <ClientDetails formSkeleton={formSkeleton} activeTab={activeTab} setActiveTab={setActiveTab}/>
        }
        {
          activeTab == 2 && 
           <VKyc />
        }
    </ DashBoard>
  )
}

export default ClientDetailDashBoard